import React from "react";
import { RadioButtons } from "@yoti/ui-kit-components-react/radio-buttons";
import styles from "./SelectDevices.module.scss";
import { Panel } from "../../Panel/Panel";

const FAKE_TYPES = {
  HARDWARE: "Hardware",
  VIRTUAL_CAMERA: "Virtual Camera",
  EMULATOR: "Emulator",
};

const fakeTypeOptions = Object.values(FAKE_TYPES).map((value) => ({
  id: value,
  label: value,
  value,
}));

const FakeType = ({ value, onChange }) => (
  <div className={styles.root}>
    <Panel>
      <div className={styles.text}>
        <h3>Fake Type</h3>
      </div>
      <div className={styles.radio_align_start}>
        <RadioButtons
          options={fakeTypeOptions}
          selectedValue={value}
          onChange={onChange}
        />
      </div>
    </Panel>
  </div>
);

export default FakeType;
